namespace $.$$ {
	export class $bog_bzrl_app_benefit extends $.$bog_bzrl_app_benefit {}
	export class $bog_bzrl_app_benefit_owners extends $.$bog_bzrl_app_benefit_owners {}
	export class $bog_bzrl_app_benefit_verified extends $.$bog_bzrl_app_benefit_verified {}
	export class $bog_bzrl_app_benefit_secure extends $.$bog_bzrl_app_benefit_secure {}
}
